import React, { useEffect, useState } from "react";
import Header from "../component/menu/Header";
import { constants, sortingOptions2 } from "../constant/constants";
import SideMenu from "../component/menu/SideMenu";
import { ConfigProvider, message, notification, Pagination, Spin } from "antd";
import ApiService from "../utils/ApiService";
import useUserStore from "../stores/store";
import RestaurantItemComponent from "../component/RestaurantItemComponent";
import CustomLoader from "../component/menu/CustomLoader";
import DataNotFound from "../component/common/DataNotFound";
import TableHeaderComponent from "../component/TableHeaderComponent";

const records = [];

function Restaurant() {
  const { user } = useUserStore();
  const [searchText, setSearchText] = useState("");
  const [sortBy, setSortBuy] = useState("NEWEST");
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  const [restaurants, setRestaurants] = useState(null);
  const [totalRestaurants, setTotalRestaurants] = useState(0);
  const [params, setParams] = useState({
    searchKey: searchText,
    status: "",
    sortBy: sortBy,
    page: currentPage,
    perPage: perPage,
  });

  const [currentRestaurantId, setCurrentRestaurantId] = useState(null);
  const [isEditClicked, setIsEditClicked] = useState(false);
  const [loadingRestaurant, setLoadingRestaurant] = useState(true);

  const onClickAddButton = (value) => {
    setSearchText("");
  };

  const onSearchText = (value) => {
    setSearchText(value);
    setParams((prev) => ({
      ...prev,
      searchKey: value,
      page: 1, // Reset to first page on new search
      perPage: perPage,
    }));
  };

  const onSortRecord = (value) => {
    setSortBuy(value);
    setParams((prev) => ({
      ...prev,
      sortBy: value,
      page: 1, // Reset to first page on new search
      perPage: perPage,
    }));
  };

  async function getRestaurantList(params) {
    params.perPage = perPage;
    params.sortBy = params.sortBy.toLowerCase();
    const token = user.token.token;
    try {
      const { payload } = await ApiService.GET_RESTAURANTS(params, token);
      setRestaurants(payload.records);
      setCurrentPage(payload.page);
      setTotalRestaurants(payload.total);
    } catch (error) {
      message.error("Failed to fetch restaurant list");
    } finally {
      setLoadingRestaurant(false);
    }
  }

  const onShowSizeChange = (current, pageSize) => {
    setPerPage(pageSize);
    setCurrentPage(current);
  };

  const onPageChange = (value) => {
    setCurrentPage(value);
    setParams((prev) => ({
      ...prev,
      page: value,
    }));
  };
  useEffect(() => {
    getRestaurantList(params);
  }, [params]);

  return (
    <div className="flex flex-col bg-[#e5e7eb]">
      <CustomLoader />
      <Header title={""} menu={constants.SUPER_MENU.RESTAURANT} currentMenuKey={'T_51_S_51'}/>
      <div className="flex flex-row bg-prewhite">
        <SideMenu
          title={`McDonalds Food Chain`}
          menu={constants.SUPER_MENU.RESTAURANT}
        />
        <div className="flex flex-row p-[24px] w-full mt-[80px] ml-[72px]">
          <div className="flex flex-col w-full">
            <TableHeaderComponent
              pageRoute={"/restaurants-create"}
              searchText={searchText}
              setSearchText={setSearchText}
              sortingOptions={sortingOptions2}
              onChangeSorting={onSortRecord}
              record={{
                title: "All Restaurant",
                hint: "Search in restaurant",
                callback: onClickAddButton,
                search: onSearchText,
              }}
            />
            <div className="flex flex-col">
            {loadingRestaurant && restaurants == null ? (
                <div className="h-[70vh] flex items-center justify-center">
                  <Spin size="large" />
                </div>
              ) : restaurants?.length > 0 ? (
                restaurants.map((item, index) => {
                  return (
                    <div key={`res-${index}`}>
                      <RestaurantItemComponent
                        record={{
                          id: item.id,
                          _name: item.name,
                          logo: item.logo,
                          status: item.status,
                          createdAt: item.createdAt,
                          setIsEditClicked: setIsEditClicked,
                        }}
                        setRestaurantId={setCurrentRestaurantId}
                      />
                    </div>
                  );
                })
              ) : (
                <DataNotFound />
              )}

              {}
            </div>
            <div className="flex flex-row justify-start font-uregular">
              <ConfigProvider
                theme={{
                  components: {
                    Pagination: {
                      itemActiveBg: "#FFD700",
                      fontFamily: "ubold",
                      colorPrimaryBorder: "#FFD700",
                      colorPrimary: "#111111",
                      colorPrimaryHover: "#111111",
                      itemInputBg: "#111111",
                      itemBg: "#E5E4E9",
                    },
                  },
                }}
              >
                <Pagination
                  total={totalRestaurants}
                  showSizeChanger={false}
                  onShowSizeChange={onShowSizeChange}
                  showTotal={(total) => `Total ${total} items`}
                  defaultPageSize={perPage}
                  defaultCurrent={currentPage}
                  current={currentPage}
                  onChange={onPageChange}
                />
              </ConfigProvider>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Restaurant;
